import request from "./../utils/request";

export function getVisitors(
    limit = 25,
    skipCount = 1,
    startDate = null,
    endDate = null,
    query = null,
    userId = null,
    point,
    description,
    homeSite,
    videoCall,
    lostChats,
    subjectId = null,
    refs = null,
    closedByAgent = null,
    visitorId = null,
    tags = null,
    downloadAsFile = false,
    channelIds = [],
    destroyers,
    starters
) {
    const qs = {
        limit: limit,
        skipCount: skipCount,
        dateBegin: startDate,
        dateEnd: endDate,
        query: query,
        userId: userId,
        subjectId,
        point,
        description,
        homeSite,
        videoCall,
        lostChats,
        refs,
        closedByAgent,
        visitorId,
        tags,
        downloadAsFile,
        channelIds,
        destroyers,
        starters
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key] || qs[key] == "null") {
            delete qs[key];
        }
    });

    return request.get("/conversations/history", {
        params: qs,
    });
}

let customerDomainsFetchPromise = null;

export function getCustomerDomains() {
    let result = customerDomainsFetchPromise || request.get("/conversations/customerDomains");
    customerDomainsFetchPromise = result;
    customerDomainsFetchPromise.catch(() => {
        customerDomainsFetchPromise = null;
    });
    return result;
}

export function getVisitorList(data) {
    return request.post("/visitors/visitor-list", data);
}

export function downloadVisitorList(data) {
    return request.post("/visitors/visitor-list/download", data);
}

export function deleteVisitor(id) {
    return request.delete(`/visitors/${id}`);
}

export function deleteMultiVisitor(ids) {
    return request.post(`/visitors/delete-multi-visitor`, {
        ids,
    });
}

export function deleteTagVisitor({ visitorId, tagId }) {
    return request.get(`/visitors/delete-tag-visitor/${visitorId}`, {
        params: { tagId },
    });
}

export function updateTagVisitor({ visitorId, tagIds }) {
    return request.post(`/visitors/updateTagVisitor/${visitorId}`, { tagIds });
}

export function getVisitor(id) {
    return request.get(`/visitors/${id}?ignoreSource=webVisitor-${Date.now()}`, {
        timeout: 1000 * 3,
    });
}

export function getBannedVisitors(perPage = 25, page = 1) {
    return request.get("/bannedVisitors/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
        },
    });
}

export const fetchChatHistory = async (siteId, visitorId, page, perPage = 5) => {
    return request({
        url: `/visitors/${visitorId}/chat-history?page=${page}&perPage=${perPage}`,
        method: "post",
    });
};

export function deleteBannedVisitor(id) {
    return request.post(`/visitors/${id}/unblock`);
}

export function banVisitor(id) {
    return request.post(`/visitors/${id}/block`);
}

export const addVisitorRepresentatives = async (siteId, visitorId, userId) => {
    return request.post(`/visitors/${visitorId}/add-representatives`, { userId });
};

export const removeVisitorRepresentatives = async (siteId, visitorId, userId) => {
    return request.post(`/visitors/${visitorId}/remove-representatives`, { userId });
};

export const updatePreferredAgents = async (visitorId, userIds) => {
    return request.post(`/visitors/${visitorId}/update-preferred-agents`, { userIds });
};

export const updatePreferredDepartment = async (visitorId, departmentId) => {
    return request.post(`/visitors/${visitorId}/update-preferred-department`, { departmentId });
};
export const createContactProperty = async (visitorId, payload) => {
    return request.post(`/visitors/${visitorId}/contact-property`, payload);
};

export const deleteContactProperty = async (visitorId, contactPropertyId) => {
    return request.delete(`/visitors/${visitorId}/contact-property/${contactPropertyId}`);
};

export const updateContactProperty = async (visitorId, contactPropertyId, updatePayload) => {
    return request.put(`/visitors/${visitorId}/contact-property/${contactPropertyId}`, updatePayload);
};

export const updateVisitorAttr = async (visitorId, updatePayload) => {
    return request.put(`/visitors/${visitorId}`, updatePayload);
};

export const getNotes = async (visitorId) => {
    return request.get(`/visitors/${visitorId}/notes`);
};

export const getLastNote = async (visitorId) => {
    return request.get(`/visitors/${visitorId}/last-note`, {
        timeout: 1000 * 3,
    });
};

export const getVisitorActivity = async (visitorId) => {
    return request.get(`/activity/${visitorId}`);
};

export const getOtherProfiles = async (visitorId) => {
    return request.get(`/visitors/other-profiles/${visitorId}`);
};

export const mergeVisitors = async (payload) => {
    return request.post(`/visitors/merge-visitors`, payload);
};

export const searchVisitor = async (q) => {
    return request.get(`/visitors/search?q=${q}`).then((res) => res.data);
};

export const importWhatsappContacts = async (siteId, userId, channelId, contacts) => {
    return request.get(`/visitors/search?q=${q}`).then((res) => res.data);
};

export const getVisitorNotes = async (visitorId) => {
    return request.get(`/visitors/${visitorId}/notes-v2`).then((res) => res.data);
};

export const createVisitorNote = async (visitorId, payload) => {
    return request.post(`/visitors/${visitorId}/notes-v2`, payload).then((res) => res.data);
};

export const updateVisitorNote = async (visitorId, noteId, payload) => {
    return request.post(`/visitors/${visitorId}/notes-v2/${noteId}`, payload).then((res) => res.data);
};

export const CONTACT_API = {
    listContacts: async (cursor, filters, sort) => {
        return request
            .post(`/visitors/contacts`, {
                filters,
                cursor,
                sort,
            })
            .then((res) => res.data);
    },
    listContactsV2: async (payload) => {
        return request
            .post("/contacts/v2", payload)
            .then((res) => res.data);
    },
    listContactsByFilterGroups: async (filterGroups, cursor, projectionFields) => {
        return request
            .post(`/visitors/contacts-by-advanced-filter`, {
                filterGroups,
                cursor,
                projectionFields,
            })
            .then((res) => res.data);
    },
    bulkActionContacts: async (visitorIds, action, payload) => {
        return request
            .post(`/contacts/bulk-action`, {
                visitorIds,
                action,
                payload,
            })
            .then((res) => res.data);
    },
};

export const deleteVisitorNote = async (noteId) => {
    const res = await request.delete(`/visitors/notes-v2/${noteId}`);
    return res.data;
};

export const updateVisitorMultiKey = async (visitorId, updatingFields) => {
    const res = await request.post(`/visitors/${visitorId}/update/`, {
        updatingFields,
    });
    return res.data;
};

export const getVisitorMediaByChatId = async (visitorId) => {
    const res = await request.get(`/visitors/${visitorId}/media`);
    return res.data;
};

export const getContactByField = async (field, query) => {
    return request
        .get(`/contacts/search-fields`, {
            params: { field, q: query },
        })
        .then((res) => res.data);
};

export const createContact = async (payload) => {
    return request.put(`/contacts`, payload).then((res) => res.data);
};

export const createMultipleContacts = async (contacts, platform, channelIds, advancedSettings) => {
    return request.post(`/contacts/multiple`, {
        contacts,
        platform,
        channelIds,
        advancedSettings
    }).then((res) => res.data);
};

export const moveContactsToOtherChannel = async (sourceChannelId, targetChannelId) => {
    return request.post(`/contacts/move-channel`, {
        sourceChannelId,
        targetChannelId
    }).then((res) => res.data);
};

export const downloadChatHistoryExcel = async (params = {}) => {
    return request({
        url: '/conversations/download-history-excel',
        method: 'get',
        params: params
    });
};
